import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from '@/axios'
import config from '@/constant/config'
import { toResponse } from '@/utils/common'

const { api } = config

export const getHighlightSections = createAsyncThunk(
  'highlightSection/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(api.highlightSection)
      return response.data
    } catch(err) {
      return rejectWithValue(toResponse(err.response))
    }
  }
)

export const getHighlightSectionDetail = createAsyncThunk(
  'highlightSection/getDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(api.highlightSectionDetail(id))
      return response.data
    } catch(err) {
      return rejectWithValue(toResponse(err.response))
    }
  }
)

export const saveHighlightSection = createAsyncThunk(
  'highlightSection/save',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(api.highlightSection, body)
      return response.data
    } catch(err) {
      return rejectWithValue(toResponse(err.response))
    }
  }
)

export const updateHighlightSection = createAsyncThunk(
  'highlightSection/update',
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const response = await axios.put(api.highlightSectionDetail(id), body)
      return response.data
    } catch(err) {
      return rejectWithValue(toResponse(err.response))
    }
  }
)

export const updateHighlightSectionSequence = createAsyncThunk(
  'highlightSection/updateSequence',
  async ({ id, sequence }, { rejectWithValue }) => {
    try {
      const response = await axios.put(api.highlightSectionSequence(id), { sequence })
      return response.data
    } catch(err) {
      return rejectWithValue(toResponse(err.response))
    }
  }
)

export const deleteHighlightSection = createAsyncThunk(
  'highlightSection/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(api.highlightSectionDetail(id))
      return response.data
    } catch(err) {
      return rejectWithValue(toResponse(err.response))
    }
  }
)

export const highlightSectionSlice = createSlice({
  name: 'highlightSection',
  initialState: {},
  reducers: {}
})

export default highlightSectionSlice.reducer
